import EventWrapper from '../utils/EventWrapper';

export default class SlotPlayer {
	constructor(defaultCoins) {
		this.defaultCoins = defaultCoins;
		this.coins = this.defaultCoins;
		this.changeCoinsEvents = [];
		this.winCoins = 0;
		this.changeWinCoinsEvents = [];
		this.level = 0;
		this.changeLevelEvents = [];
		this.levelProgress = 0;
		this.changeLevelProgressEvents = [];
		this.levelUpReward = 0;
		this.useLevelUpReward = false;
		this.score = 0;
	}

	addCoins(count) {
		this.setCoinsCount(this.coins + count);
	}

	setCoinsCount(count) {
		count = Math.max(0, count);
		var changed = this.coins != count;
		this.coins = count;
		if (changed) {
			this.changeCoinsEvents.forEach(eW => {
				if (eW != null && eW.action != null) eW.action.call(eW.context, this.coins);
			});
		}
	}

	addChangeCoinsEvent(event, context) {
		if (event != null) this.changeCoinsEvents.push(new EventWrapper(event, context));
	}

	addWinCoins(count) {
		this.setWinCoinsCount(this.winCoins + count);
	}

	setWinCoinsCount(count) {
		count = Math.max(0, count);
		var changed = this.winCoins != count;
		this.winCoins = count;
		this.score += count;
		if (changed) {
			this.changeWinCoinsEvents.forEach(eW => {
				if (eW != null && eW.action != null) {
					eW.action.call(eW.context, this.winCoins);
				}
			});
		}
	}

	addWinCoinsChangeEvent(event, context) {
		if (event != null) this.changeWinCoinsEvents.push(new EventWrapper(event, context));
	}

	takeWin() {
		this.addCoins(this.winCoins);
		this.setWinCoinsCount(0);
	}

	addLevel(count) {
		this.setLevel(this.level + count);
	}

	setLevel(count) {
		count = Math.max(0, count);
		var changed = this.level != count;
		var addLevels = count - this.level;
		this.level = count;
		if (changed) {
			this.changeLevelEvents.forEach(eW => {
				if (eW != null && eW.action != null)
					eW.action.call(eW.context, this.level, Pahser.Math.Max(0, addLevels * this.levelUpReward), this.useLevelUpReward);
			});
		}
	}

	addChangeLevelEvent(event, context) {
		if (event != null) this.changeLevelEvents.push(new EventWrapper(event, context));
	}

	addLevelProgress(count) {
		this.setLevelProgress(this.levelProgress + count);
	}

	setLevelProgress(count, raiseEvent) {
		count = Math.max(0, count);
		if (count >= 100) {
			var addLevels = Math.floor(count / 100);
			this.addLevel(addLevels);
			count = 0;
		}

		var changed = this.levelProgress != count;
		this.levelProgress = count;

		if (changed && raiseEvent) {
			this.changeLevelProgressEvents.forEach(eW => {
				if (eW != null && eW.action != null) eW.action.call(eW.context, this.levelProgress);
			});
		}
	}

	addChangeLevelProgressEvent(event, context) {
		if (event != null) this.changeLevelProgressEvents.push(new EventWrapper(event, context));
	}

	setDefaultData() {
		this.setCoinsCount(this.defaultCoins);
		this.setLevel(0);
		this.setLevelProgress(0);
	}

	hasMoneyForBet(totalBet) {
		return totalBet <= this.coins;
	}
}
